<template>
  <v-card
    style="margin-bottom: 10em; margin-top: 10em !important;"
    class="ml-2"
    v-if="toggleAccountPreferences"
  >
    <v-toolbar class="elevation-0">
      <v-icon color="primary">edit</v-icon>

      <v-toolbar-title
        :style="`color: ${$vuetify.theme.primary}`"
      >{{$translate('ACCOUNT_TITLE_CREATE_STYLE')}}</v-toolbar-title>
    </v-toolbar>
    <v-card-text class="scrollable_account_activation">
      <v-form ref="userGroupForm" v-model="valid" lazy-validation>
        <h2 :style="`color: ${$vuetify.theme.primary}`">{{AccountInfo.AccountName}}</h2>

        <v-text-field
          v-model="form.AccountDescription"
          :rules="textRules"
          :label="$translate('ACCOUNT_DESCRIPTION')"
          required="required"
          :autocomplete="$translate('ACCOUNT_DESCRIPTION')"
        ></v-text-field>

        <v-layout row class="text-xs-center">
          <div class="text-xs-center">
            <h4>Primary color</h4>
            <v-flex>
              <v-menu
                ref="primary_color"
                :close-on-content-click="false"
                :nudge-right="40"
                lazy
                transition="scale-transition"
                offset-y
                full-width
              >
                <v-btn slot="activator" :color="primaryColor">{{primaryColor}}</v-btn>
                <sketch-picker :value="primaryColor" @input="e => primaryColor = e.hex"/>
              </v-menu>
            </v-flex>
          </div>

          <div class="text-xs-center">
            <h4>Secondary color</h4>
            <v-flex>
              <v-menu
                ref="secondary_color"
                :nudge-right="40" 
                :close-on-content-click="false"
                lazy
                transition="scale-transition"
                offset-y
                full-width
              >
                <v-btn slot="activator" :color="secondaryColor">{{secondaryColor}}</v-btn>
                <sketch-picker :value="secondaryColor" @input="e => secondaryColor = e.hex"/>
              </v-menu>
            </v-flex>
          </div>
        </v-layout>
        <image-loader class="mt-4" :properties="properties" v-on:load_logo="setImageElement"></image-loader>
        <image-loader class="mt-4" :properties="properties2" v-on:load_image="setImageElement"></image-loader>
      </v-form>
    </v-card-text>
    <v-dialog v-model="confirmDialog" max-width="290" hide-overlay>
      <v-card class="round_dialog_roles">
        <v-card-title
          class="headline"
          :style="`color: ${$vuetify.theme.primary}`"
        >{{$translate('ACCOUNT_CONFIRMATION')}}</v-card-title>
        <v-card-text>{{$translate('ACCOUNT_SELECTION_CONFIRMATION')}}</v-card-text>
        <v-card-text>{{$translate('ACCOUNT_CHANGES_LATER')}}</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="secondary"
            round
            @click.native="confirmDialog = false"
          >{{$translate('CANCEL')}}</v-btn>
          <v-btn
            color="primary"
            :loading="loadingConfirmation"
            :disabled="disableUpdate"
            round
            @click.native="updateAccount()"
          >{{$translate('YES')}}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn
        class="v-btn-2"
        :loading="loading"
        :disabled="loading"
        round
        color="primary"
        @click="confirmDialog = true"
      >{{$translate('NEXT')}}</v-btn>
    </v-card-actions>

  </v-card>
</template>

<script>
import ImageLoader from "@/components/media/ImageLoader";
import { Sketch } from "vue-color";
import { store } from "../../store.js";
import * as dssRequest from "@/api/dssRequest";
import UserObject from "@/objects/UserObject";
import { mapGetters } from "vuex";
import appConfig from "../../../config/app_config";
import { calculateAspectRatioFit } from "@/shared/utility";
import { optionalTextRulesTo128 } from "@/shared/validations_rules";
import { ui_helpers } from "@/shared/ui_helpers";
import BaseComponent from "../base/BaseComponent.vue";
import activateAccount from "../activateAccount";

export default {
  extends: BaseComponent,
  name: "Account_Activation",
  mixins: [ui_helpers],
  components: {
    ImageLoader,
    "sketch-picker": Sketch
  },
  computed: {
    ...mapGetters({
      AccountInfo: "getAccountInfo"
    })
  },
   data() {
    return {
      toggleAccountPreferences: false,
      disableUpdate: false,
      loadingConfirmation: false,
      confirmDialog: false,
      primaryColor: "",
      secondaryColor: "",
      valid: true,
      properties: {
        title: "Main logo",
        signalName: "load_logo",
        deletable: false,
        pictureUrl: "",
        maxWidth: appConfig.maxSize.logo.w,
        maxHeight: appConfig.maxSize.logo.h,
        scale: "h"
      },
      properties2: {
        title: "Background",
        signalName: "load_image",
        deletable: false,
        pictureUrl: "",
        maxWidth: appConfig.maxSize.home.w,
        maxHeight: appConfig.maxSize.home.h,
        scale: "w"
      },
      loading: false,
      form: {
        AccountDescription: "",
        logo: null,
        image: null,
        Preferences: {}
      },
      link: "",
      textRules: optionalTextRulesTo128
    };
  },
  created() {
    this.activateAccount()
  },
  mounted() {
    this.primaryColor = this.customerPreferences.Primary_color;
    this.secondaryColor = this.customerPreferences.Secondary_color;

    this.properties.pictureUrl = this.customerPreferences.Linda_empty;
    this.form.logo = this.customerPreferences.Linda_empty;
    this.properties2.pictureUrl = this.customerPreferences.Background_image;
    this.form.image = this.customerPreferences.Background_image;
  },
  methods: {
    activateAccount() {
      // query for data from URL
      const userID = this.$route.query.UserID;
      store.commit("auth/setUserName", userID);
      const email = this.$route.query.email;
      const passwordHash = this.$route.query.token;

      //Account activation OBJ
      this.activateObj = UserObject._createActivateUserObject(
        appConfig.login.clientSecret,
        email,
        userID,
        passwordHash,
        "t"
      );

      //Activate account
      dssRequest.doRequest(
        response => {
          console.log("The call for 'activateAccount' on - Account_activation.vue - was successful", response);
          let user = new UserObject(userID, email, "t", userID);
          if (!response.data.hasOwnProperty('access_token') ||
            !response.data.hasOwnProperty('refresh_token')
          ) {
            // window.EventBus.fire('triggerGenericErrorDialog', 'W_AA_001');
            return;
          }
          this.$store.commit("auth/setToken", response.data.access_token);
          this.$store.commit("auth/setRefreshToken", response.data.refresh_token);

          user.userlogin(
            r => {
              this.$store.commit("setWebStepId", -3);
              this.toggleAccountPreferences = true;
            },
            e => {
              console.log("activateUser error", e.errorMsg);
            }
          );
        },
        error => {
          console.log("The call for 'activateAccount' on - Account_activation.vue - was not successful", error);
          // window.EventBus.fire('triggerGenericErrorDialog', 'W_AA_002');
        },
        "activateAccount",
        store.getters.getCurrentAccountId,
        this.activateObj,
        600000,
        false
      );

    },
    updateAccount() {
      if (this.$refs.userGroupForm.validate()) {
        this.disableUpdate = true;
        this.loadingConfirmation = true;
        this.loading = true;
        const payload = JSON.parse(JSON.stringify(this.form));
        payload.Preferences[0] = {
          Key: "Header_logo",
          Value: this.form.logo,
          Type: "image"
        };
        payload.Preferences[1] = {
          Key: "Primary_color",
          Value: this.primaryColor,
          Type: "color"
        };
        payload.Preferences[2] = {
          Key: "Secondary_color",
          Value: this.secondaryColor,
          Type: "color"
        };
        payload.Preferences[3] = {
          Key: "Background_image",
          Value: this.form.image,
          Type: "image"
        };
        delete payload.logo;
        delete payload.image;
        dssRequest.doRequest(
          response => {
            console.log("The call for 'updateAccount' on - Account_activation.vue -  was successful", response);
            this.loadingConfirmation = false;
            this.loading = false;
            this.link = response.data.Link;
            window.EventBus.fire("getAccountInfo", {});
            window.EventBus.fire(
              "activateSnackBar",
              this.$translate("ACCOUNT_SAVED_OK")
            );
            setTimeout(() => {
              this.showComponents({
                main: "EventView_Main",
                side: "EventView_Overview"
              });
              this.$store.commit("setWebStepId", 2);
            }, 2000);
          },
          error => {
            console.log("The call for 'updateAccount' on - Account_activation.vue - was not succesfull", error);
            this.loading = false;
            this.loadingConfirmation = false;
            this.disableUpdate = false;
            // window.EventBus.fire('triggerGenericErrorDialog', 'W_UA_001');
          },
          "updateAccount",
          store.getters.getCurrentAccountId,
          payload,
          600000,
          false
        );
      }
    },
    updateCustomerPreferences(data) {
      this.properties.pictureUrl = data.Linda_empty;
      this.form.logo = data.Linda_empty;
      this.properties2.pictureUrl = data.Background_image;
      this.form.image = data.Background_image;
    },
    setImageElement(e) {
      if (e.signalName == this.properties.signalName) {
        this.form.logo = e.url;
      } else if (e.signalName == this.properties2.signalName) {
        this.form.image = e.url;
      }
    },
  }
};
</script>

<style>
.scrollable_account_activation {
  height: 40vh;
  overflow-x: hidden;
  overflow-y: auto;
}
.small_border {
  border: 2px solid #c0c0c0 !important;
  border-radius: 10%;
}
</style>
